import PageIntroBand from 'components/PageIntroBand';
import { FlowButton } from 'components/ui/flow-button';
import { SupportHero, SupportRail, SupportSection, SupportList, SupportFaqs } from 'components/PublicSupportLayout';

export default function ServiceDetailDesign({ state }) {
  const service = state.data;
  if (!service) return <section className="support-state site-content-shell" aria-busy={state.loading || undefined}>
    <p className="support-label">Services</p>
    <h1>{state.loading ? 'Loading service.' : state.error ? 'Services are temporarily unavailable.' : 'This service page is unavailable.'}</h1>
    <div className="support-actions">{state.error && <FlowButton onClick={state.retry}>Try again</FlowButton>}<FlowButton to="/services">View services</FlowButton></div>
  </section>;

  const rows = service.contentRows || [];
  const pillars = service.pillars?.length ? service.pillars : [
    { label: 'Context', value: service.context }, { label: 'Pressure', value: service.risk }, { label: 'Timing', value: service.when },
  ].filter(item => item.value);
  const meta = [...(service.metaBlocks || []), ...(service.metrics || [])];
  const groups = [
    ['operating-questions', 'Operating questions', 'Questions to bring into focus.', service.operatingQuestions],
    ['problems', 'Current challenges', 'What usually breaks.', service.problems],
    ['builds', 'Operating structure', 'What to build next.', service.builds],
    ['process', 'The process', 'How the work moves forward.', service.process],
  ].filter(([, , , items]) => items?.length);
  return <>
    <SupportHero testId="service-detail-hero" backPath="/services" backLabel="Services" targetId="service-overview" content={{
      eyebrow: service.eyebrow, title: service.title, body: service.description,
      imageUrl: service.heroImageUrl || service.cardImageUrl || '', imageAlt: service.heroImageAlt || service.title,
      primaryCtaLabel: service.cta || 'Discuss this service', primaryCtaPath: '/#contact',
      secondaryCtaLabel: 'Explore the service', secondaryCtaPath: '#service-overview',
    }} />
    <SupportRail testId="service-detail-moving-strip" items={[service.eyebrow || service.title, 'Operating context', 'Responsibilities', 'Deliverables', 'Agreed scope', 'Follow-up']} />
    <PageIntroBand testId="service-detail-intro" label={service.cardLabel || service.eyebrow || 'Service overview'}
      title={service.leadStatement || service.overviewDescription || service.description} backgroundText="SERVICES"
      paragraphs={[service.context, service.risk].filter(Boolean)} />

    <section id="service-overview" className="support-section support-overview" aria-label="Service overview">
      <div className="site-content-shell">
        {service.overviewDescription && service.overviewDescription !== service.leadStatement && <p className="support-overview-description">{service.overviewDescription}</p>}
        {!!meta.length && <dl className="support-facts">{meta.map((item, index) => <div key={index}><dt>{item.label}</dt><dd>{item.value}</dd></div>)}</dl>}
        {!!rows.length && <div className="support-editorial-rows">{rows.map((row, index) => <article key={index}>
          <div><p className="support-label">{row.eyebrow || String(index + 1).padStart(2, '0')}</p><h2>{row.title}</h2>{row.leftText && <p className="support-row-intro">{row.leftText}</p>}</div>
          {row.rightText && <p className="support-row-copy">{row.rightText}</p>}
        </article>)}</div>}
      </div>
    </section>

    {!!pillars.length && <SupportSection id="service-pillars" label="01 / Operating pillars" title="What the work has to hold together." tint>
      <div className="support-pillars">{pillars.map((item, index) => <article key={index}><span className="support-number">{String(index + 1).padStart(2, '0')}</span><h3>{item.label}</h3><p>{item.value}</p></article>)}</div>
    </SupportSection>}
    {groups.map(([id, label, title, items]) => <SupportSection key={id} id={'service-' + id} label={label} title={title}><SupportList items={items} /></SupportSection>)}
    <SupportSection id="service-deliverables" label="02 / Deliverables" title="What the company receives."><SupportList items={service.deliverables || []} /></SupportSection>
    <SupportFaqs items={service.faqs} id="service-faq" />
    <SupportSection id="service-next-step" label={service.eyebrow || 'Next step'} title={service.when || service.cardResult || service.description} tint>
      <div className="support-actions"><FlowButton to="/#contact">{service.cta || 'Discuss this service'}</FlowButton><FlowButton to="/paperwork?view=compare">View Paperwork Packages</FlowButton></div>
    </SupportSection>
  </>;
}
